import React from 'react';
import { Box, TextField } from '@mui/material';
import { EditButton } from '../button';
import { useColorMode } from '../colorMode';
const EditableField = React.forwardRef(({ editable, locked: locked_, value: value_, onEdit, onSave, ...props }, ref) => {
    const colorMode = useColorMode();
    const [locked, setLocked] = React.useState(locked_);
    const [value, setValue] = React.useState(typeof value_ === 'string' ? value_ : '');
    const handleEdit = (event) => {
        setLocked(false);
        onEdit?.(event);
    };
    const handleSubmit = () => {
        const result = onSave?.(value);
        if (result) {
            setLocked(true);
        }
    };
    React.useEffect(() => setValue(typeof value_ === 'string' ? value_ : ''), [value_]);
    return (React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center' }, ref: ref },
        React.createElement(TextField, { sx: { flex: 1, colorScheme: colorMode.isThemeDark ? 'dark' : undefined }, disabled: locked, onChange: (e) => setValue(e.target.value), defaultValue: value, inputProps: {
                sx: {
                    overflowY: 'hidden',
                    '&:hover': props.multiline ? { overflowY: 'initial' } : undefined,
                    textAlign: props.type === 'number' ? 'right' : undefined,
                },
            }, InputProps: {
                endAdornment: editable && (props.type != 'datetime-local' || locked) ? (React.createElement(EditButton, { locked: locked, onEdit: handleEdit, onSave: handleSubmit })) : undefined,
            }, ...props }),
        editable ? (props.type != 'datetime-local' || locked ? null : (React.createElement(EditButton, { locked: locked, onEdit: handleEdit, onSave: handleSubmit }))) : null));
});
export default EditableField;
